import React, { useEffect, useRef } from "react";
import { withFormik, Field, Formik, Form } from "formik";
import { FormikField, PhoneInputUs } from "../..";
import Constant from "../../../utils/constant";
import { emailPattern, phoneNumberPattern } from "../../../config/const";
import { unFormatPhoneNumber } from "../../../Common/unFormatPhoneNumber";
import { FormGroup } from "@material-ui/core";
import validationSchema from "../../../Validation/ValidationSchemas";
import FormikTextField from "../../../Common/FormFields/FormikInputField";

const ContactUsDetailForm = (props) => {
  const { touched, errors, isSubmitting } = props;
  const formRef = useRef();
  const formatNumber = (phNumber) => {
    let cleaned = ("" + phNumber).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let inputString = "(" + match[1] + ") " + match[2] + "-" + match[3];
      formRef.current.setFieldValue("phoneNumber", inputString);
    }
  };
  return (
    <div className="form-container">
      <Formik
        innerRef={formRef}
        validationSchema={validationSchema.contactUsSchema}
        initialValues={{
          name: "",
          email: "",
          phoneNumber: "",
          subject: "",
          message: "",
        }}
        onSubmit={(values, { resetForm }) => {
          props.submitContactUs(values, resetForm);
        }}
      >
        {(formik) => (
          <Form>
            <div>
              <div className="grid-col-container">
                <FormikTextField
                  label="Your Name"
                  formik={formik}
                  fieldName="name"
                  placeholder="Enter Your name"
                  labelFontSize="fs-18"
                />
              </div>

              <div className="two-column-row">
                <div className="grid-col-container">
                  <FormikTextField
                    label="Email"
                    formik={formik}
                    fieldName="email"
                    placeholder="Enter Your Email"
                    labelFontSize="fs-18"
                  />
                </div>
                <div className="grid-col-container">
                  <FormGroup>
                    <label className="fmlabel mt-6 semi-bold">
                      Phone Number <span className="redstar">*</span>
                    </label>
                    <Field
                      className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect ${
                        formik.errors.phoneNumber && "is-invalid"
                      }`}
                      type="text"
                      name="phoneNumber"
                      onKeyUp={(e) => formatNumber(e.target.value)}
                      placeholder="Enter phone Number"
                      maxLength={14}
                    />
                    <div className="errorMessage fs-14 medium">
                      {formik.errors.phoneNumber}
                    </div>
                  </FormGroup>
                </div>
              </div>

              <div className="grid-col-container mt-20">
                <FormikTextField
                  label="Subject"
                  formik={formik}
                  fieldName="subject"
                  placeholder="Enter Subject"
                  labelFontSize="fs-18"
                />
              </div>

              <div className="grid-col-container">
                <FormGroup>
                  <label className="fmlabel mt-6 semi-bold ">
                    Any Message <span className="redstar">*</span>
                  </label>
                  <Field
                    as="textarea"
                    name="message"
                    className={`form-control w-100 faqanswerbox ${
                      formik.errors.message && "is-invalid"
                    }`}
                    rows="4"
                    cols="50"
                    placeholder="Enter message here..."
                  />
                  <div className="errorMessage">{formik.errors.message}</div>
                </FormGroup>
              </div>

              <div
                className={`form-item form-button-item mg-top-20 ${
                  !formik.isValid && "inactive-btn"
                }`}
              >
                <button disabled={!formik.isValid} type="submit">
                  Send Request
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export const ContactUsForm = withFormik({
  mapPropsToValues: (props) => {
    return {
      name: props?.name || "",
      email: props?.email || "",
      phoneNo: unFormatPhoneNumber(props?.phoneNo) || "",
      subject: props?.subject || "",
      message: props?.message || "",
    };
  },
  validate: (values) => {
    let errors = {};
    if (!values.name) {
      errors.name = Constant.EMPTY_NAME;
    } else if (!values.email) {
      errors.email = Constant.EMPTY_EMAIL;
    } else if (!emailPattern.test(values.email)) {
      errors.email = Constant.INVALID_EMAIL;
    } else if (!values.phoneNo) {
      errors.phoneNo = Constant.EMPTY_PHONE;
    } else if (!phoneNumberPattern.test(values.phoneNo)) {
      errors.phoneNo = Constant.INVALID_PHONE;
    } else if (!values.subject) {
      errors.subject = Constant.EMPTY_SUBJECT;
    } else if (!values.message) {
      errors.message = Constant.EMPTY_MESSAGE;
    }
    return errors;
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.submitContactUs(values, resetForm);
  },
})(ContactUsDetailForm);
